import { Button } from "components/Button";
import styled from "styled-components/macro";
import type { ElearningThemeInterface } from "themes/elearningInterface.theme";

interface Props {
  theme: ElearningThemeInterface;
}

export const StyledAccessibilityMenuButton = styled(Button)<Props>`
  text-align: left;
  font-size: ${({ theme }) => theme.font.size._14};
  margin: unset;

  .content {
    display: flex;
    gap: 0rem 0.5rem;
    color: ${(props: Props) => props.theme.palette.neutral.white};
  }

  svg {
    height: 1.2rem;
  }
`;
